import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { IMailAttachment } from "@calaosoft/osapp-common/conversations/models/imail-attachment";
import { ModalController } from "@ionic/angular";
import { Message } from "../../../modules/conversations/model/message";
import { ModalComponentBase } from "../../../modules/modal";
import { PlatformService } from "../../../services/platform.service";

@Component({
	selector: "calao-mail-detail-modal",
	templateUrl: "./mail-detail-modal.component.html",
	styleUrls: ["./mail-detail-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class MailDetailModalComponent extends ModalComponentBase<any> implements OnInit {
	//#region PROPERTIES

	@Input() public title = "";
	@Input() public message?: Message;
	@Input() public attachements?: IMailAttachment[] = [];

	//#endregion

	//#region METHODS

	constructor(poModalCtrl: ModalController, isvcPlatform: PlatformService) {
		super(poModalCtrl, isvcPlatform);
	}

	public getTotalAttachmentsSize(paAttachments?: IMailAttachment[]): string {
		const pnSize: number = paAttachments?.reduce((acc, att) => acc + (att.size || 0), 0) || 0;
		return this.getSizeInKo(pnSize);
	}

	public getAttachmentSize(attachment: IMailAttachment): string {
		const size = attachment.size || 0;
		return this.getSizeInKo(size);
	}

	private getSizeInKo(size: number): string {
		return size ? `${Math.ceil(size / 1024)} Ko` : "0 Ko";
	}

	//#endregion
}
